const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPeoplePlus(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(2 -2)",
    style: {
      fill: "#1f62b9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "container",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(2 -2)",
    style: {
      fill: "#1f62b9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1166"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 114",
    transform: "translate(11 16)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h18"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 115",
    transform: "translate(20 7)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0v18"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPeoplePlus);
export default __webpack_public_path__ + "static/media/btn-people-plus.c2f86c89184f23e1fc8565ff96411d17.svg";
export { ForwardRef as ReactComponent };